(function () {
  const config = window.__giftWithPurchaseConfig;
  if (!config || !config.triggerProductIds?.length || !config.giftVariantId) return;

  let isSyncing = false;

  function getCartSectionIds() {
    const nodes = document.querySelectorAll(
      '[data-section-type="cart-drawer"], [data-section-type="cart"]'
    );
    return Array.from(nodes)
      .map((el) => el.dataset.sectionId)
      .filter(Boolean);
  }

  // Solo actualiza el CONTENIDO interno de cada sección, nunca el nodo raíz
  // (así el drawer nunca pierde su estado de abierto/cerrado ni sus listeners)
  function updateSectionsPartially(sections, cartItemCount) {
    Object.keys(sections).forEach((sectionId) => {
      const target = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!target) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(sections[sectionId], 'text/html');
      const newSection = doc.querySelector(`[data-section-id="${sectionId}"]`);
      if (!newSection) return;

      const partsToSync = [
        '[data-items-holder]',
        '[data-cart-price-holder]',
        '[data-cart-count]'
      ];

      partsToSync.forEach((selector) => {
        const oldPart = target.querySelector(selector);
        const newPart = newSection.querySelector(selector);
        if (oldPart && newPart) {
          // Saca data-animation de este nodo y de todos sus hijos,
          // así no dependen del scroll-observer que nunca los va a ver
          if (newPart.hasAttribute('data-animation')) {
            newPart.removeAttribute('data-animation');
          }
          newPart.querySelectorAll('[data-animation]').forEach((el) => {
            el.removeAttribute('data-animation');
          });

          oldPart.replaceWith(newPart);
        }
      });

      target.classList.toggle('is-empty', cartItemCount === 0);
    });

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function cartHasTrigger(cart) {
    return cart.items.some((item) =>
      config.triggerProductIds.includes(item.product_id)
    );
  }

  // Clave del fix #2: solo cuenta como "el regalo" la línea que TIENE
  // la property _gift === 'true'. Una compra manual del mismo producto
  // no tiene esa property, así que nunca se confunde ni se borra.
  function cartHasGift(cart) {
    return cart.items.find(
      (item) =>
        item.variant_id === config.giftVariantId &&
        item.properties &&
        item.properties._gift === 'true'
    );
  }

  async function addGift() {
    const sections = getCartSectionIds().join(',');
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: config.giftVariantId,
            quantity: 1,
            properties: { _gift: 'true' }
          }
        ],
        sections
      })
    });
    const data = await res.json();
    const cart = await getCart();
    if (data.sections) updateSectionsPartially(data.sections, cart.item_count);
  }

  async function removeGift(giftLine) {
    const sections = getCartSectionIds().join(',');
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftLine.key, quantity: 0, sections })
    });
    const data = await res.json();
    const cart = await getCart();
    if (data.sections) updateSectionsPartially(data.sections, cart.item_count);
  }

  async function syncGift() {
    if (isSyncing) return;
    isSyncing = true;

    try {
      const cart = await getCart();
      const hasTrigger = cartHasTrigger(cart);
      const giftLine = cartHasGift(cart);

      if (hasTrigger && !giftLine) {
        await addGift();
      } else if (!hasTrigger && giftLine) {
        await removeGift(giftLine);
      }
    } catch (err) {
      console.error('gift-with-purchase error:', err);
    } finally {
      isSyncing = false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const response = await originalFetch.apply(this, args);

    if (
      response.ok &&
      /\/cart\/(add|change|update|clear)(\.js)?/.test(url) &&
      !isSyncing
    ) {
      setTimeout(syncGift, 150);
    }

    return response;
  };

  document.addEventListener('DOMContentLoaded', syncGift);
})();